module.exports = __webpack_public_path__ + "img/c6.c006c599.png";